<template>
  <v-menu
    ref="datemenu"
    v-model="datemenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        readonly
        solo
        dense
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker :value="value" @input="emitChange" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="
          () => {
            $emit('input', null);
            $emit('change');
            $refs.datemenu.save();
          }
        "
        >Clear</v-btn
      >
      <v-btn text color="primary" @click="datemenu = false">Cancel</v-btn>
      <v-btn
        text
        color="primary"
        @click="
          () => {
            $emit('change');
            $refs.datemenu.save();
          }
        "
        >OK</v-btn
      >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  inheritAttrs: false,
  props: {
    value: { default: null },
    label: { type: String, default: "Select date" },
    dense: { type: Boolean, default: true },
  },
  data() {
    return {
      datemenu: false,
    };
  },
  computed: {
    dateFormatted() {
      if (this.value == null) return null;
      if (Array.isArray(this.value)) return null;
      return moment(this.value, "YYYY-MM-DD").format("Do MMM YYYY");
    },
  },
  methods: {
    emitChange(v) {
      if (v) this.$emit("input", v);
    },
  },
};
</script>

<style>
</style>